import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchPendingVarieties() {
  try {
    const result = yield call(AxiosCall, `/mycore/mushroom-context/pending/`);

    yield put(actions.fetchPendingVarietiesSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchPendingVarietiesFailure(e));
  }
}

function* approveVariety(action) {
  try {
    const { variety_id, notes } = action.payload;
    const payload = notes ? { notes } : {};

    yield call(AxiosPost, `/mycore/mushroom-context/${variety_id}/approve/`, payload);

    yield put(actions.approveVarietySuccess());
  } catch (e) {
    yield put(actions.approveVarietyFailure(e.message));
  }
}

function* rejectVariety(action) {
  try {
    const { variety_id, notes } = action.payload;
    const payload = notes ? { notes } : {};

    yield call(AxiosPost, `/mycore/mushroom-context/${variety_id}/reject/`, payload);

    yield put(actions.rejectVarietySuccess());
  } catch (e) {
    yield put(actions.rejectVarietyFailure(e.message));
  }
}

function* promoteVariety(action) {
  try {
    const { variety_id, notes } = action.payload;
    const payload = notes ? { notes } : {};

    yield call(AxiosPost, `/mycore/mushroom-context/${variety_id}/promote/`, payload);

    yield put(actions.promoteVarietySuccess());
  } catch (e) {
    yield put(actions.promoteVarietyFailure(e.message));
  }
}

export default function* varietyApprovalSaga() {
  yield all([
    takeLatest(actions.FETCH_PENDING_VARIETIES.REQUEST, fetchPendingVarieties),
    takeLatest(actions.APPROVE_VARIETY.REQUEST, approveVariety),
    takeLatest(actions.REJECT_VARIETY.REQUEST, rejectVariety),
    takeLatest(actions.PROMOTE_VARIETY.REQUEST, promoteVariety),
  ])
}
